import styled, { css } from 'styled-components';

interface ChartContainerProps {
  size?: string;
}

interface IChart {
  color: string;
}

export const ChartContainer = styled.div<ChartContainerProps>`
  ${({ }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    .labelLegend {
      display: flex;
      justify-content: flex-end;
      margin-right: 10px;
      font-family: Arial;
      font-size: 13px;
    }

    .google-visualization-tooltip {
      pointer-events: none !important;
    }

    .hAxis {
      font-family: Arial;
      font-size: 11px;
      font-style: italic;
      fill: #222222;
      margin: 0 auto;
      text-align: center;
    }

    .legenda {
      flex: 1;
      font-size: 12px;
      margin-top: 10px;

      h3 {
        font-size: 12px;
      }
    }

    .legenda .lista {
      list-style: none;
      padding: 0;
      max-height: 300px;
      column-width: 150px;
      column-gap: 20px;
      overflow-y: auto;
    }

    .legenda .elemento {
      margin-bottom: 6px;
      display: flex;
      align-items: center;
      break-inside: avoid;
    }

    //TODO Remover depois de aprovado
    // .legenda .lista {
    //   list-style: none;
    //   padding: 0;
    //   max-height: 300px;
    //   overflow-y: auto;
    //   list-style-type: none;
    //   padding: 0;
    //   margin: 0;
    //   display: flex;
    //   flex-wrap: wrap;
    // }

    // .legenda .lista .elemento {
    //   display: flex;
    //   margin-bottom: 6px;
    //   flex: 1 0 100%; /* Itens ocupam 100% da largura inicialmente */
    // }

    // .legenda .lista:has(.elemento:nth-child(n + 10)) .elemento {
    //   flex: 1 0 50%; /* Quando tem mais de 10 itens, divide em duas colunas */
    // }

    .google-visualization-tooltip {
      padding: 4px !important;
      background-color: #000 !important;
      border: 1px solid black;
      border-radius: 4px;
    }

    .google-visualization-tooltip .google-visualization-tooltip-item-list {
      padding: 0 !important;
      margin: 0 !important;
    }

    .google-visualization-tooltip .google-visualization-tooltip-item-list .google-visualization-tooltip-item {
      padding: 0 !important;
      margin: 0 !important;
    }

    .google-visualization-tooltip .google-visualization-tooltip-item-list .google-visualization-tooltip-item span {
      padding: 0 !important;
      margin: 0 !important;
      color: white !important;
      white-space: nowrap;
      font-weight: 600;
    }
  `}
`;

export const Icon = styled.div<IChart>`
  ${({ color }) => css`
    width: 15px;
    height: 15px;
    background-color: ${color};
    margin-right: 6px;
    border-radius: 2px;
    flex-grow: 0;
    flex-shrink: 0;
  `}
`;
